import React from 'react';
import { IRouteDetailsKeyValueProps } from '../../../../../sp-types/routeDetailsType';

export const RouteDetailsKeyValue: React.FC<IRouteDetailsKeyValueProps> = ({ data }) => {
  return (
    <div className="flex">
      <div className="grid grid-cols-2 border text-sm border-gray-300 ">
        {data.map((row, index) => (
          <React.Fragment key={index}>
            <div className="border border-gray-300 p-2 bg-gray-50">{row.label}</div>
            <div className="border border-gray-300 p-2">{row.value}</div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
